import axios from './axios';
import type { Incident, IncidentListItem } from '../types';

export function getIncidents(
  projectId: number,
  filters?: { status?: string; month?: string; details?: boolean }
): Promise<Array<Incident>> {
  return axios.get(`/projects/${projectId}/incidents.json`, { params: filters })
    .then(response => response.data);
}

export function createIncident(
  projectId: number,
  incident: Partial<Incident>
): Promise<Incident> {
  return axios.post(`/projects/${projectId}/incidents.json`, incident)
    .then(response => response.data);
}

export function updateIncident(
  projectId: number,
  incidentId: number,
  incident: Partial<Incident>
): Promise<Incident> {
  return axios.put(`/projects/${projectId}/incidents/${incidentId}.json`, incident)
    .then(response => response.data);
}

export function deleteIncident(projectId: number, incidentId: number): Promise<{ message: string }> {
  return axios.delete(`/projects/${projectId}/incidents/${incidentId}.json`)
    .then(response => response.data);
}

export function getAllIncidents(
  filters?: { project_id?: number; status?: string; month?: string }
): Promise<Array<IncidentListItem>> {
  return axios.get('/incidents.json', { params: filters })
    .then(response => response.data);
}

export function getUnresolvedIncidentsCount(): Promise<number> {
  return axios.get('/incidents/unresolved_count.json')
    .then(response => response.data.unresolved_incidents_count);
}
